// Generated by Melange

import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../packages/util/lib/DateTime.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../../../proto/third_party/google_wkt/gen/google_protobuf_timestamp.js";

const include = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const make = include.make;

function fromMillis(milliseconds) {
  const seconds = milliseconds / 1000 | 0;
  const nanos = Math.imul(milliseconds - Math.imul(seconds, 1000) | 0, 1000000);
  return Curry._3(make, seconds, nanos, undefined);
}

function toMillis(timestamp) {
  return Math.imul(timestamp.seconds, 1000);
}

function fromString(value) {
  return fromMillis(DateTime.toMillis(DateTime.fromDateFormat(value)));
}

function toDateTime(timestamp) {
  return DateTime.fromSeconds(timestamp.seconds);
}

const to_proto = include.to_proto;

const from_proto = include.from_proto;

const to_json = include.to_json;

const from_json = include.from_json;

const name = include.name;

const merge = include.merge;

const to_proto$p = include.to_proto$p;

const from_proto_exn = include.from_proto_exn;

const from_json_exn = include.from_json_exn;

export {
  make,
  to_proto,
  from_proto,
  to_json,
  from_json,
  name,
  merge,
  to_proto$p,
  from_proto_exn,
  from_json_exn,
  fromMillis,
  toMillis,
  fromString,
  toDateTime,
}
/* DateTime Not a pure module */
